import { useEffect } from 'react';
import posthog from 'posthog-js';
import { useAuth } from '../../hooks/useAuth';
import { useAccess } from '../access';
import Logger from '../../utils/logger';

// Make PostHog available globally for scripts
if (typeof window !== 'undefined') {
  (window as any).posthog = posthog;
}

export function AnalyticsIdentifier() {
  const { user } = useAuth(); // This is the mapped user (sub, email, name, permissions)
  const { access, isLoading: isAccessLoading } = useAccess();

  useEffect(() => {
    if (user && access && !isAccessLoading) {
      const userToIdentify = {
        id: user.sub,
        email: user.email,
        name: user.name,
        permissions: user.permissions,
        subscription_start_date: access.subscription_start_date,
        subscription_end_date: access.subscription_end_date,
        subscription_active: access.subscription_active,
      };

      if (user.sub && user.email) {
        // Identify user in PostHog
        posthog.identify(user.sub, userToIdentify);
      } else {
        Logger.warn('User missing sub or email');
      }
    }
  }, [user, access, isAccessLoading]);

  return null;
}
